import { Component, Input, OnInit } from '@angular/core';
import { TranslationService } from '../../../services/translation.service';

export interface Link {
  title: string;
  url: string;
}

@Component({
  selector: 'zui-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  translated;
  @Input() logoSelector = 'conti';
  @Input() links: Link[] = [];
  @Input() copyRightText: string;
  year: number;

  constructor(public translationService: TranslationService) {
    this.translated = translationService.getTranslation(); // translations[this.lang];
  }
  ngOnInit(): void {
    this.initializeLinks();
    this.initializeCopyRightText();
  }

  initializeLinks() {
    if (!this.links.length) {
      switch (this.logoSelector) {
        case 'default':
          this.links = [
            {
              title: this.translated.footer.supportLink,
              url: 'https://zonarsystemshelp.zendesk.com/hc/en-us'
            },
            {
              title: this.translated.footer.termsAndConditionsLink,
              url: 'https://zonarsystems.com/terms-of-use/ground-traffic-control'
            },
            {
              title: this.translated.footer.dataDisclosureLink,
              url: 'https://zonarsystems.com/data-disclosure/ground-traffic-control/'
            }
          ];
          break;
        case 'conti':
          this.links = [
            {
              title: this.translated.footer.supportLink,
              url: 'https://www.continental-mobility-services.com/en-en/products/cvi/#support'
            },
            {
              title: this.translated.footer.termsAndConditionsLink,
              url: 'https://www.continental-mobility-services.com/en-en/footer-navigation/legal-notice/'
            },
            {
              title: this.translated.footer.dataDisclosureLink,
              url: 'https://www.continental-mobility-services.com/en-en/footer-navigation/data-protection/'
            }
          ];
          break;
      }
    }
  }

  initializeCopyRightText() {
    this.year = new Date().getFullYear();
    if (!this.copyRightText) {
      switch (this.logoSelector) {
        case 'default':
          this.copyRightText = 'Zonar Systems';
          break;
        case 'conti':
          this.copyRightText = 'Continental AG';
          break;
      }
    }
  }

  useBrand(input = 'default') {
    if (this.logoSelector === input) {
      return true;
    }
    return false;
  }
}
